import { mapAnswersToJokerUsedIndices } from "../shared/model/GameStatsEvaluation";
import { VerticalDistributionComponent } from "../shared/components/VerticalDistributionComponent";
import { useMemo } from "react";
import { getFinalScoreDistribution } from "../shared/model/GameStatsEvaluation";

export function JokerStatsComponent({ data }) {

  const jokerUsedDistribution = useMemo(() => {
    const jokersUsed = data?.map(x => x.answers).map(mapAnswersToJokerUsedIndices);
    return getFinalScoreDistribution(jokersUsed.flat())
  }, [data]);

  const wasted = useMemo(() => data?.filter(x => x.stats.wastedJokers > 0).length, [data]);
  const wastedShare = useMemo(() => (wasted / data?.length).toPrecision(4) * 100, [data, wasted]);
  
  return (
    <section className="vertical-container justify">
      <span className="small bottom-margin">Joker sind als <i>verschwendet</i> definiert, wenn eine Frage <i>falsch</i> beantwortet wurde, obwohl <i>noch ein Joker verfügbar</i> gewesen wäre.</span>

      <div className="vertical-container top-margin gap-1">
        <span>
          Du hast in
          <span className="glow primary horizontal-padding"> {wasted} </span>
          {wasted === 1 ? "Spiel" : "Spielen"} mindestens einen Joker verschwendet. Das sind
          <span className="glow primary horizontal-padding"> {wastedShare}% </span>
          aller deiner Spiele.
        </span>

        <div>
          Verteilung der <span className="">Joker-Einsätze</span>:
          <VerticalDistributionComponent values={jokerUsedDistribution} />
        </div>
      </div>
    </section>
  );
}
